import { SVGProps } from 'react'

export function BlackjackIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M25.4744 10.2572L22.1558 20.372C21.9465 21.0754 21.579 21.7216 21.0815 22.2611C20.584 22.8005 19.9697 23.2189 19.2855 23.4842C19.6489 22.6374 19.8358 21.7254 19.8349 20.8038V11.078C19.8328 9.27307 19.1151 7.54261 17.8391 6.2663C16.5631 4.98999 14.8331 4.27206 13.0286 4.27H11.4097C12.0101 3.47553 12.8392 2.8839 13.7856 2.5746C14.7321 2.26531 15.7505 2.25315 16.704 2.53978L22.2327 4.2379C23.4531 4.61715 24.4763 5.45998 25.0824 6.5854C25.6885 7.71083 25.8292 9.02911 25.4744 10.2572Z'
				fill='currentColor'
				transform='scale(0.85) translate(-1,-1)'
			/>
			<path
				d='M17.8902 11.078V20.8038C17.8887 22.0931 17.376 23.3291 16.4646 24.2407C15.5532 25.1523 14.3175 25.6652 13.0286 25.6667H7.19464C5.90573 25.6652 4.67005 25.1523 3.75865 24.2407C2.84725 23.3291 2.33455 22.0931 2.33301 20.8038L2.33301 11.078C2.33455 9.7888 2.84725 8.5528 3.75865 7.64117C4.67005 6.72953 5.90573 6.2167 7.19464 6.21515H13.0286C14.3175 6.2167 15.5532 6.72953 16.4646 7.64117C17.376 8.5528 17.8887 9.7888 17.8902 11.078Z'
				fill='currentColor'
				transform='scale(0.85) translate(-1,-1)'
			/>
		</svg>
	)
}
